import type { AlertProps, IconNames } from '@petsmart-ui/sparky';
import { Alert, AlertBody, Heading, LayoutLinelengthContainer, TextPassage } from '@petsmart-ui/sparky';
import type { PropsWithChildren } from 'react';

export type AlertBannerProps = PropsWithChildren & {
    header?: string;
    iconName?: IconNames;
    variant?: AlertProps['variant'];
    className?: string;
    dismissible?: boolean;
};

export function AlertBanner({
    header,
    iconName,
    variant = 'error',
    className,
    children,
    dismissible,
}: AlertBannerProps) {
    return (
        <Alert
            variant={variant}
            iconName={iconName}
            className={className}
            data-testid="alert-banner"
            dismissible={dismissible}
        >
            <AlertBody>
                <LayoutLinelengthContainer>
                    {header && (
                        <Heading tagName="h2" size="body-bold">
                            {header}
                        </Heading>
                    )}
                </LayoutLinelengthContainer>
                <TextPassage>{children}</TextPassage>
            </AlertBody>
        </Alert>
    );
}
